import React, { PureComponent } from "react";
import { ErrorMessage, Form, Formik } from "formik";
import { object } from "yup";
import * as Yup from "yup";
import { Button, Grid, Input, Label } from "semantic-ui-react";

export class ChangePasswordForm extends PureComponent {
  render() {
    return (
      <>
        <Formik
          enableReinitialize
          validateOnChange
          initialValues={{
            password: ""
          }}
          validationSchema={object().shape({
            password: Yup.string()
              .required("Password is required!")
              .min(3, "At least 3 characters required!")
          })}
          onSubmit={(values, { setSubmitting }) => {
            this.props.onSubmit(values);
            setSubmitting(false);
          }}
        >
          {({ dirty, errors, handleBlur, isSubmitting, isValid, setFieldValue, touched, values }) => (
            <Form widths="equal">
              <Grid padded>
                <Grid.Row>
                  <h3>Enter the new password</h3>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <h4>Password:</h4>
                  </Grid.Column>
                  <Grid.Column width={4} stretched textAlign="center">
                    <Input
                      value={values.password}
                      onChange={(e, data) => setFieldValue("password", data.value)}
                      fluid
                      name="password"
                      type="password"
                      placeholder="Password"
                      data-test="password"
                      onBlur={handleBlur}
                      icon="user secret"
                      iconPosition="left"
                    />
                    <ErrorMessage name="password" component={Label} basic pointing color="red" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={4} textAlign="right">
                    <Button size="medium" color="orange" content={"Save"} type="submit" />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default ChangePasswordForm;
